export default __webpack_public_path__ + "static/media/pencil-cold-winter.3da0e317.png";